// extracted by mini-css-extract-plugin
export default {"fab":"FloatingActionButton_fab__eGQrS"};